import React from "react";
import { graphql } from "gatsby";
import { Layout, Head } from "@components";
import PostList from "./PostList";
import styles from "@styles/PostList.module.scss";
import CategoryIcon from "@assets/icons/category.svg";

type Props = {
	pageContext: {
		category: string
		categories: { category: string, count: number, href: string }[];
		tags: { tag: string, count: number, href: string }[];
	}
	data: {
		allMarkdownRemark: {
			edges: {
				node: {
					frontmatter: {
						category: string[]
						date: string
						slug: string
						description: string
						tags: string[]
						title: string
					}
				}
			}[]
		}
	}
}

const PostListByCategory: React.FC<Props> = ({
	data, pageContext: { categories, tags, category }
}) => (
	<Layout categories={ categories } tags={ tags } hideNavBtnIfSmallDevice={ true }>
		<Head/>
		<section className={ styles.title }>
			<img src={ CategoryIcon }/>
			<h2>{category}</h2>
		</section>
		<PostList
			categories={ categories }
			tags={ tags }
			posts={ data.allMarkdownRemark.edges.map(
				({ node: { frontmatter } }) => ({ ...frontmatter })) }
		/>
	</Layout>
);

export const pageQuery = graphql`
	query ($category: String!) {
		allMarkdownRemark(
			filter: {frontmatter: {category: { eq: $category }}}
			sort: {fields: frontmatter___date, order: DESC},
		) {
			edges {
				node {
					frontmatter {
						slug
						category
						date(formatString: "YYYY년 MM월 DD일")
						tags
						title
						description
					}
				}
			}
		}
	}
`;

export default PostListByCategory;
